module.exports = __webpack_public_path__ + "d2cc59be4659450bb24ea0438e09f481.svg";